(function () {
  if (window.__clearRecentSearchesLoaded) return;
  window.__clearRecentSearchesLoaded = true;

  var REMOVED_SEARCHES_KEY = 'removed_search_keywords';
  var SEARCH_COUNT_KEY = 'search_keywords_count';
  var predictiveSearchResizeTimer = 0;
  var predictiveSearchMutationTimer = 0;

  /* ── localStorage helpers ── */

  function getRemovedSearches() {
    try { return JSON.parse(localStorage.getItem(REMOVED_SEARCHES_KEY)) || []; }
    catch (e) { return []; }
  }

  function getSearchCounts() {
    try { return JSON.parse(localStorage.getItem(SEARCH_COUNT_KEY)) || {}; }
    catch (e) { return {}; }
  }

  function incrementSearchCount(keyword) {
    var normalized = (keyword || '').trim().toLowerCase();
    if (!normalized) return;
    var counts = getSearchCounts();
    counts[normalized] = (counts[normalized] || 0) + 1;
    localStorage.setItem(SEARCH_COUNT_KEY, JSON.stringify(counts));
  }

  function getPredictiveSearchWidth() {
    var root = document.documentElement;
    var predictiveSearchEls = Array.from(
      document.querySelectorAll('.predictive-search .search-input'),
    );

    if (!predictiveSearchEls.length) {
      root.style.removeProperty('--predictive-search-width');
      return;
    }

    var targetEl =
      predictiveSearchEls.find(function (el) {
        return el instanceof HTMLElement && el.offsetWidth > 0;
      }) || predictiveSearchEls[0];

    if (!(targetEl instanceof HTMLElement)) {
      root.style.removeProperty('--predictive-search-width');
      return;
    }

    var inputWidth = Math.round(targetEl.getBoundingClientRect().width);

    root.style.setProperty('--predictive-search-width', inputWidth + 'px');
  }

  function bindPredictiveSearchWidthVar() {
    getPredictiveSearchWidth();

    window.addEventListener('resize', function () {
      clearTimeout(predictiveSearchResizeTimer);

      predictiveSearchResizeTimer = setTimeout(function () {
        getPredictiveSearchWidth();
      }, 120);
    });
  }

  /* ── Clear all recent searches ── */

  function clearAllRecentSearches() {
    var allKeywords = [];

    document.querySelectorAll('.suggestion-queries-container').forEach(function (container) {
      var items = container.querySelectorAll('.boost-sd__suggestion-queries-item--recent');

      items.forEach(function (item) {
        var title = (item.getAttribute('data-title') || '').trim().toLowerCase();
        if (title && allKeywords.indexOf(title) === -1) allKeywords.push(title);
      });

      // Only hide the list, keep header + clear button
      var list = container.querySelector('.boost-sd__suggestion-queries-list');
      if (list) list.style.display = 'none';
    });

    // Save removed keywords
    var existing = getRemovedSearches();
    var merged = existing.concat(allKeywords).filter(function (v, i, a) {
      return a.indexOf(v) === i;
    });
    localStorage.setItem(REMOVED_SEARCHES_KEY, JSON.stringify(merged));

    // Reset counts for cleared keywords so new searches start fresh
    var counts = getSearchCounts();
    allKeywords.forEach(function (kw) {
      delete counts[kw];
    });
    localStorage.setItem(SEARCH_COUNT_KEY, JSON.stringify(counts));
  }

  /* ── Filter removed keywords ── */

  function filterRemovedRecentSearches() {
    var removed = getRemovedSearches();
    if (!removed.length) return;

    document.querySelectorAll('.suggestion-queries-container').forEach(function (container) {
      var items = container.querySelectorAll('.boost-sd__suggestion-queries-item--recent');
      var visibleCount = 0;

      items.forEach(function (item) {
        var title = (item.getAttribute('data-title') || '').trim().toLowerCase();
        if (removed.indexOf(title) !== -1) {
          item.style.display = 'none';
        } else {
          visibleCount++;
        }
      });

      if (visibleCount === 0) {
        var list = container.querySelector('.boost-sd__suggestion-queries-list');
        if (list) list.style.display = 'none';
      }
    });
  }

  /* ── Inject Clear button ── */

  function injectClearButton() {
    var headers = document.querySelectorAll('.boost-sd__suggestion-queries-header--recent');

    headers.forEach(function (header) {
      if (header.closest('.boost-sd__suggestion-queries-header-wrapper')) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'boost-sd__suggestion-queries-header-wrapper';

      header.parentElement.insertBefore(wrapper, header);
      wrapper.appendChild(header);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'boost-sd__clear-recent-searches';
      btn.setAttribute('aria-label', 'Clear recent searches');
      btn.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<mask id="mask0_clear_btn" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">' +
        '<rect width="24" height="24" fill="#D9D9D9"/>' +
        '</mask>' +
        '<g mask="url(#mask0_clear_btn)">' +
        '<path d="M12 13.0538L6.92701 18.127C6.78851 18.2653 6.61443 18.3362 6.40476 18.3395C6.19526 18.3427 6.01801 18.2718 5.87301 18.127C5.72818 17.982 5.65576 17.8063 5.65576 17.6C5.65576 17.3937 5.72818 17.218 5.87301 17.073L10.9463 12L5.87301 6.92701C5.73468 6.78851 5.66385 6.61443 5.66051 6.40476C5.65735 6.19526 5.72818 6.01801 5.87301 5.87301C6.01801 5.72818 6.19368 5.65576 6.40001 5.65576C6.60635 5.65576 6.78201 5.72818 6.92701 5.87301L12 10.9463L17.073 5.87301C17.2115 5.73468 17.3856 5.66385 17.5953 5.66051C17.8048 5.65735 17.982 5.72818 18.127 5.87301C18.2718 6.01801 18.3443 6.19368 18.3443 6.40001C18.3443 6.60635 18.2718 6.78201 18.127 6.92701L13.0538 12L18.127 17.073C18.2653 17.2115 18.3362 17.3856 18.3395 17.5953C18.3427 17.8048 18.2718 17.982 18.127 18.127C17.982 18.2718 17.8063 18.3443 17.6 18.3443C17.3937 18.3443 17.218 18.2718 17.073 18.127L12 13.0538Z" fill="#054F8E"/>' +
        '</g>' +
        '</svg>' +
        '<span>Clear</span>';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearAllRecentSearches();
      });

      wrapper.appendChild(btn);
    });
  }

  /* ── Track search submissions ── */

  var lastTrackedSearch = '';
  var lastTrackedTime = 0;

  function restoreFromRemoved(normalized) {
    var removed = getRemovedSearches();
    var idx = removed.indexOf(normalized);
    if (idx !== -1) {
      removed.splice(idx, 1);
      localStorage.setItem(REMOVED_SEARCHES_KEY, JSON.stringify(removed));
    }
  }

  function trackOnce(query) {
    var normalized = query.trim().toLowerCase();
    var now = Date.now();
    if (!normalized || (normalized === lastTrackedSearch && now - lastTrackedTime < 2000)) return;
    lastTrackedSearch = normalized;
    lastTrackedTime = now;
    incrementSearchCount(query);
    restoreFromRemoved(normalized);
  }

  function trackSearchSubmissions() {
    // Use capture phase to catch events before Boost SDK can intercept
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;

      var boostInput = e.target.closest('.boost-sd__search-widget-init-input');
      var themeInput = e.target.closest('input[name="q"]');
      var input = boostInput || themeInput;

      if (!input) return;

      var query = input.value.trim();
      if (query) trackOnce(query);
    }, true);

    // Track form submissions
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('.predictive-search-form, form[action*="search"]')) return;

      var input = form.querySelector('input[name="q"], .boost-sd__search-widget-init-input');
      if (!input) return;

      var query = input.value.trim();
      if (query) trackOnce(query);
    }, true);

    // Track clicks on recent search links (also count)
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.boost-sd__suggestion-queries-item--recent a');
      if (!link) return;

      var item = link.closest('.boost-sd__suggestion-queries-item--recent');
      if (!item) return;

      var title = (item.getAttribute('data-title') || '').trim();
      if (title) trackOnce(title);
    }, true);
  }

  /* ── Main process ── */

  function processRecentSearches() {
    injectClearButton();
    filterRemovedRecentSearches();
  }

  // MutationObserver to re-inject after Boost SDK re-renders
  var observer = new MutationObserver(function () {
    clearTimeout(predictiveSearchMutationTimer);
    predictiveSearchMutationTimer = setTimeout(function () {
      getPredictiveSearchWidth();
    }, 120);

    var header = document.querySelector('.boost-sd__suggestion-queries-header--recent');
    if (header && !header.closest('.boost-sd__suggestion-queries-header-wrapper')) {
      processRecentSearches();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  bindPredictiveSearchWidthVar();
  trackSearchSubmissions();
})();
